import prepareFile from '@/components/controls/DropScan/prepareFile';
import { getFileInBlob } from '@/utils/modifiers';

const getFileBlob = async (file: File | undefined) => {
  if (file) {
    const preparedFile = prepareFile(file);
    const blob = await getFileInBlob(preparedFile.preview);
    return blob;
  }
  throw new Error();
};

export default getFileBlob;
